import { IDi, IDiDecorator, Register, RegisterProps } from "../domain/Di";

//

class DiService {
  createInstance<
    Registers extends Record<string, Register>,
    C extends new (registers: (props: RegisterProps) => Registers) => IDi<Registers>,
  >(constructor: C, registers: (props: RegisterProps) => Registers) {
    return new constructor(registers);
  }

  //

  createDecoratorInstance<Tokens extends string>(constructor: new () => IDiDecorator<Tokens>) {
    return new constructor();
  }
}

//

export default new DiService();
